//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        data() {
            return {
                beforeCompressFileLength:"",
                afterCompressFileLength:"",
                CompressFileErr:"",

                inPlayerPlaya:"",
                not_vjscontrolbar:"",
                initVideoPlayerBor:"",
                startLearning:"",
                beforeLearingSupervised:"",
                beforeONPLAY:"",
                beforeplay:"",
                beforesupervisedFace:""
            }
        },
        mounted(){
            this.beforeCompressFileLength=localStorage.getItem("beforeCompressFileLength");
            this.afterCompressFileLength=localStorage.getItem("afterCompressFileLength");
            this.CompressFileErr=localStorage.getItem("CompressFileErr");

            this.inPlayerPlaya=localStorage.getItem("inPlayerPlaya");
            this.not_vjscontrolbar=localStorage.getItem("not_vjscontrolbar");
            this.initVideoPlayerBor=localStorage.getItem("initVideoPlayerBor");
            this.startLearning=localStorage.getItem("startLearning");
            this.beforeLearingSupervised=localStorage.getItem("beforeLearingSupervised");
            this.beforeONPLAY=localStorage.getItem("beforeONPLAY");
            this.beforeplay=localStorage.getItem("beforeplay");beforesupervisedFace
            this.beforesupervisedFace=localStorage.getItem("beforesupervisedFace");
        }
    }



// WEBPACK FOOTER //
// ./src/view/webdebug.vue